<div  *ngIf="Loaded$ | async; else loading">
    <h1 mat-dialog-title>Zeiterfassung</h1>
    <mat-dialog-content class="content">
        <mat-form-field appearance="outline" class='wide-mat-select'>
            <mat-label>Datum</mat-label>
            <input matInput [matDatepicker]="picker" [formControl]="form.controls.date" />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="outline" class='wide-mat-select'>
            <mat-label>{{ cls.getSingle$('Commission') | async }}</mat-label>
            <app-select-search [formControl]="form.controls.commission" [Options]="commissionOptions$ | async" [CompareOptions]="compareById"></app-select-search>
            <fa-icon matSuffix icon="times" style="margin-left: 3px; cursor: pointer;" (click)="form.controls.commission.setValue(null);$event.stopPropagation();" *ngIf="form.value.commission"></fa-icon>
        </mat-form-field>
        <mat-form-field appearance="outline" class='wide-mat-select' *ngIf="employeeOptions$ | async as employees">
            <mat-label>Mitarbeiter</mat-label>
            <mat-select [formControl]="form.controls.employee" [compareWith]="compareById" required>
                <mat-option *ngFor="let employee of employees" [value]="employee">{{ employee.DisplayName }}</mat-option>
            </mat-select>
        </mat-form-field>
    <!--    <h3 class="sub-line">Arbeitstag</h3>-->
        <mat-form-field appearance="outline" class='wide-mat-select'>
            <mat-label>Arbeitstag</mat-label>
            <app-time-span-picker-select>
                <app-time-picker-select appStartTime [required]="true" placeholder="Start" [formControl]="form.controls.startTime"></app-time-picker-select>
                <app-time-picker-select appEndTime placeholder="Ende" [min]="form.value.startTime" [offsetTimeForOptionLabel]="form.value.startTime" [formControl]="form.controls.endTime"></app-time-picker-select>
            </app-time-span-picker-select>
        </mat-form-field>
        <h3 *ngIf="form.controls.additionalTimeSpans.controls.length" class="sub-line">Zusätzliche Stempelungen:</h3>
        <mat-accordion displayMode="flat">
            <mat-expansion-panel *ngFor="let control of form.controls.additionalTimeSpans.controls; index as i; first as isFirst; last as isLast" [expanded]="expandedIndex === i" (opened)="expandedIndex = i">
                <mat-expansion-panel-header>
                    <span class="header-label">
                        {{ (control.value.startTime || ' -- ') + ' - ' + (control.value.endTime || ' -- ') }}
                    </span>
                    <button mat-icon-button class="header-button" (click)="onDeleteClick(i)"><fa-icon icon="trash"></fa-icon></button>
                </mat-expansion-panel-header>
                <div *matExpansionPanelContent class="expansion-panel-content">
                    <mat-form-field>
                        <mat-label>Zeitraum</mat-label>
                        <app-time-span-picker-select [required]="true">
                            <app-time-picker-select appStartTime [required]="true" placeholder="Start" [max]="form.value.endTime" [min]="isFirst ? form.value.startTime : form.controls.additionalTimeSpans.controls[i - 1].value.endTime" [formControl]="control.controls.startTime"></app-time-picker-select>
                            <app-time-picker-select
                                appEndTime
                                [required]="true"
                                placeholder="Ende"
                                [max]="form.value.endTime"
                                [min]="control.value.startTime"
                                [offsetTimeForOptionLabel]="control.value.startTime"
                                [formControl]="control.controls.endTime"
                            ></app-time-picker-select>
                        </app-time-span-picker-select>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Art</mat-label>
                        <mat-select [formControl]="control.controls.clockInTypeId">
                            <mat-option *ngFor="let type of clockInTypes$(control.controls.clockInTypeId.value) | async" [value]="type.Id">{{ type.Name }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>{{ cls.getSingle$('Commission') | async }}</mat-label>
                        <app-select-search [formControl]="control.controls.commissionId" [Options]="commissionOptions$ | async"></app-select-search>
                        <fa-icon matSuffix icon="times" style="margin-left: 3px; cursor: pointer;" (click)="control.controls.commissionId.setValue(null);$event.stopPropagation();" *ngIf="!control.controls.commissionId.disabled"></fa-icon>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Notiz</mat-label>
                        <input matInput type="text" [formControl]="control.controls.note" />
                    </mat-form-field>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
        <button
            mat-button
            (click)="onAddFormClick()"
            [disabled]="!(hasPermissions$ | async) || !form.value.employee"
            class="add-button"
        >
            <fa-icon icon="plus"></fa-icon> Stempelungen hinzufügen
        </button>
    </mat-dialog-content>
    <mat-dialog-actions class="buttons">
        <button app-button [IsLoading]="ls.IsLoading$ | async" Color="cancel" Inverted (click)="closeDialog()">abbrechen</button>
        <button app-button [IsLoading]="ls.IsLoading$ | async" Color="green" (click)="submit()" [Disabled]="form.invalid || !(hasPermissions$ | async)">speichern</button>
    </mat-dialog-actions>
</div>
<ng-template #loading>
    <app-loading></app-loading>
</ng-template>
